<template>
    <div id="company-disclosure">
        <div class="position_center md-layout-item" style="width:560px;">
            <h1 class=" font_bold" style="font-size: 28px; margin-bottom: 30px">{{$t('companyDisclosure.title')}}</h1>
            <div class="company-disclosure-paragraph">
                <span>TNP Global Trade GmbH<br /></span>
                <span>Carsten-Rehder-Str. 50 <br /></span>
                <span>22767 Hamburg <br /></span>
                <span>Tel.: {{carePhoneNumber}} <br /></span>
            </div>
            <div class="company-disclosure-paragraph">
                <span>{{$t('companyDisclosure.managingDirector')}}: Jörg Hörster, Hongchao Xu <br /></span>
                <span>{{$t('companyDisclosure.headquarters')}}: Hamburg <br /></span>
				<span>{{$t('companyDisclosure.registerCourt')}}: Hamburg <br /></span>
                <span>{{$t('companyDisclosure.registerNumber')}}: HRB 145 996 <br /></span>
				<span>{{$t('companyDisclosure.vatNumber')}}: DE311560698 <br /></span>
            </div>
            <div class="company-disclosure-paragraph">{{$t('companyDisclosure.contact')}}</div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            email: "",
            isSend: false,
            modelValidations: {
                email: {
                    required: true,
                    email: true
                }
            },
        };
    },
	computed: {
		...mapGetters(['carePhoneNumber'])
	}
};
</script>
<style lang="scss" scoped>
    #company-disclosure {
        div & .company-disclosure-paragraph {
            text-align: left;
            font-size: 16px;
            margin-bottom: 20px
        }
    }
</style>
